<!-- <div *ngIf="isLoading" id="overlay">
  <div id="loader-wrapper">
    <div id="loader"></div>
  </div>
</div> -->


<div  *ngIf="isLoading||anyViewLoaderEnable" id="overlay" >
  <!-- <div  class="loader-wrapper">
    <span class="spinner-loader-new spinner-border"></span>
    <img class="spinner-loader-img"  src='assets/img/GCU-logo.svg' />
  </div>  -->
  <div *ngIf="isLoading||anyViewLoaderEnable" id="overlay">
    <div id="loader-wrapper">
      <div id="loader"></div>
    </div>
  </div>
</div>




<div [dir]="direction">
  <div class="inner-header">
  <header *ngIf="!isExportableComponent"></header>
  </div>
  <div id="page-container">
    <div id="content-wrap">
      <router-outlet></router-outlet>
    </div>
    <footer id="footer" *ngIf="!isExportableComponent"></footer>
  </div>
</div>



<!-- <div [dir]="direction" style="position: relative;" style="height: 100%;" class="all-page">

  <div class="inner-header" style="position: relative;">
    <header></header>
  </div>
  <div style="position: relative; min-height: 400px;">

       <router-outlet></router-outlet>

  </div>

  <div style="position: relative;">
    <footer></footer>
  </div>

</div> -->
